import TwoColumnRepository from "../TwoColumnRepository"

export default class WhyPodiemTwoColumn extends TwoColumnRepository {
    static schemaId = "why_us_twoColumn"

    constructor() {
        super(WhyPodiemTwoColumn.schemaId)
    }
}
